import axios from 'axios';
import { AuthContextValue } from '@/contexts/auth';
import { API_PREFIX } from '@/constants';
import { CustomerStatus } from '.';
import { TaskListItem } from '..';
import { TaskListResult } from '../service';

interface QueryCustomerListParams extends Pagination {
  status: CustomerStatus;
  taskId: number;
  callIntention: UKey;
  auth: AuthContextValue;
}

export type CustomerListItem = {
  phone: string;
  allocationTimes: number;
  dailyAddFriendTimes: number;
  callIntention: string;
  copyTime?: string;
  addFriendTime?: string;
  name?: string;
}

export type CustomerDetailItem = {
  userId: string;
  allocationDate: string;
  avatar?: string;
}

export type CustomerListResult = CustomerListItem[];

export const queryCustomerList = async ({ status, taskId, current, pageSize, total, callIntention, auth }: QueryCustomerListParams) => {
  const { userId, corpId } = auth;
  const res = await axios.get<CustomerListResult>(`${API_PREFIX.CUSTOMER}/user/task/phoneList`, {
    params: {
      userId,
      corpId,
      status,
      taskId,
      pageNum: current,
      pageSize,
      callIntention
    }
  });
  if (res && res.data) {
    return {
      data: res.data,
      pagination: { current, pageSize, total }
    };
  }
}

export const queryCustomerDetail = async (number: CustomerListItem['phone'], auth: AuthContextValue) => {
  const { corpId } = auth;
  const res = await axios.get<CustomerDetailItem[]>(`${API_PREFIX.CUSTOMER}/user/task/${corpId}/${number}`, { params: { userId: 'ChenPengFei' } });
  if (res && res.data) {
    return res.data;
  }
}

export const addCustomer = async (number: CustomerListItem['phone'], auth: AuthContextValue) => {
  const { corpId, userId } = auth;
  await axios.post(`${API_PREFIX.CUSTOMER}/user/task/${corpId}/${userId}/add/${number}`);
}

export const queryTask = async (id: TaskListItem['taskId'], auth: AuthContextValue) => {
  const { corpId, userId } = auth;
  const res = await axios.get<TaskListResult>(`${API_PREFIX.CUSTOMER}/user/task/pageList`, {
    params: { taskId: id, page: 1, pageSize: 500, userId, corpId }
  });
  if (res && res.data) {
    const data = res.data.data[0];
    if (data) {
      const { waitAddNum, waitPassNum, finishNum, ...r } = data;
      return {
        ...r,
        status: {
          [CustomerStatus.toadd]: waitAddNum,
          [CustomerStatus.expecting]: waitPassNum,
          [CustomerStatus.finished]: finishNum
        }
      };
    }
  }
}
